export default __webpack_public_path__ + "static/media/rupee.7c24da5e.svg";